// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__1cUxb","dragIcon":"Choice_dragIcon__1dTvS","left":"Choice_left__3B5St","input":"Choice_input__1kuxR"};